module.exports = __webpack_public_path__ + "img/ex1.fb1fecda.jpg";